import { render, staticRenderFns } from "./ModalInfoInTable.vue?vue&type=template&id=39f96fda&lang=pug&"
import script from "./ModalInfoInTable.vue?vue&type=script&lang=js&"
export * from "./ModalInfoInTable.vue?vue&type=script&lang=js&"
import style0 from "./ModalInfoInTable.vue?vue&type=style&index=0&id=39f96fda&prod&lang=sass&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports